import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7732ec90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "noData" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "noData__img" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#no-data-icon" })
], -1))
const _hoisted_3 = { class: "noData__title" }
const _hoisted_4 = { class: "noData__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("No data")), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("no-data-text")), 1)
  ]))
}